export const userRoles = {
  Admin: 0,
  Client: 1,
};
